import run from'../../utilities/run';
import $ from'jquery';
import _ from"underscore";
import {setElementsFromScope} from"../../utilities/selectorHelpers";

const targetSelector="#received-inbound-form";

run(targetSelector, (mainEl) => {
attachOrgForm(mainEl);
});

function attachOrgForm(mainEl) {
const facilityData=mainEl.data("facility-data");
const viewUrl=mainEl.data("view-url"); 
const prevfacId=mainEl.data("facid-data");
const viewInboundRenderUrl = mainEl.data("view-inbound-render-url");

const els= {};
const elementsMap= {
addFacilitySelect :'#ibfacility-select',
}

function init() {
setElements();
bindElements();
renderFacilityList();
} 

function setElements() {
setElementsFromScope(els, elementsMap, mainEl);
}

function bindElements(){ 
els.addFacilitySelect.on('change', facilityChangeRequest); 
}

function renderFacilityList(){
    $(facilityData).each(function(){
        var option=$('<option />');
        option.attr('value', this.facId).text(this.facName);
        els.addFacilitySelect.append(option);
    });
}

function facilityChangeRequest(){
    let facId = els.addFacilitySelect.val();
    let newviewUrl=`${viewUrl}&facId=${facId}`;
    $.ajax({
       url: newviewUrl,
       type: 'POST',
       dataType: "JSON",
       data:  {
         facId:facId
       },
       success:function(response) {
        $('#progress').html((response.Planned != null) ? response.Planned : "0");
        $('#transit').html((response["In Transit"] != null) ? response["In Transit"] : "0");
        $('#received').html((response.Receiving != null) ? response.Receiving : "0"); 
        $('#progressLink').attr('href',viewInboundRenderUrl+"&filterFlag=Planned&facId="+facId);
        $('#transitLink').attr('href',viewInboundRenderUrl+"&filterFlag=In Transit&facId="+facId);
        $('#receivedLink').attr('href',viewInboundRenderUrl+"&filterFlag=Received&facId="+facId);
       },
       error: function(response){
           console.log("error"+JSON.stringify(response));
       }
     }); 
 }
 




init();
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/inbound-dashboard.js